
import style from './Background.module.css'

export const Background = () => <div className={style.Background}></div>